System.register(["./dyn-jsx-runtime.js", "./dyn-index.js", "./dyn-goober.modern.js", "./dyn-parallax-banner.js"], function(exports, module) {
  "use strict";
  var jsxRuntimeExports, reactExports, j, animate;
  return {
    setters: [(module2) => {
      jsxRuntimeExports = module2.j;
    }, (module2) => {
      reactExports = module2.r;
    }, (module2) => {
      j = module2.j;
    }, (module2) => {
      animate = module2.a;
    }],
    execute: function() {
      exports("default", FlipClock);
      const sall = (fn) => fn();
      function easeOutBounce(x) {
        const n1 = 7.5625;
        const d1 = 2.75;
        if (x < 1 / d1) {
          return n1 * x * x;
        } else if (x < 2 / d1) {
          return n1 * (x -= 1.5 / d1) * x + 0.75;
        } else if (x < 2.5 / d1) {
          return n1 * (x -= 2.25 / d1) * x + 0.9375;
        } else {
          return n1 * (x -= 2.625 / d1) * x + 0.984375;
        }
      }
      const Group = /* @__PURE__ */ j("div")({
        position: "relative",
        display: "inline-flex",
        gap: "2px",
        fontSize: "32px",
        verticalAlign: "bottom"
      });
      const GroupTitle = j("div")({
        position: "absolute",
        top: 0,
        left: "50%",
        fontSize: "8px",
        color: "var(--fc-title-color, #FFF)",
        fontWeight: "bold",
        marginBottom: "4px",
        textTransform: "capitalize",
        transform: "translateX(-50%) translateY(-100%)"
      });
      const Digit = j("div")({
        width: ".85em",
        position: "relative",
        borderRadius: ".25em",
        color: "#fafafa",
        fontWeight: "bold",
        textShadow: "0 1.5px rgba(0, 0, 0, .05)",
        textAlign: "center",
        lineHeight: 1.25,
        backgroundColor: "var(--fc-card-bg, #FFC300)",
        ".flip-spacer": {
          visibility: "hidden"
        }
      });
      const Card = j("div")({
        position: "absolute",
        width: "100%",
        height: "100%",
        borderRadius: "inherit",
        userSelect: "none",
        perspective: "4em",
        zIndex: 1
      });
      const Text = j("div")({
        width: "100%",
        height: "100%",
        whiteSpace: "nowrap",
        lineHeight: 1.25,
        textShadow: "1px 2px 5px rgba(0, 0, 0, .3)"
      });
      const Spacer = j("div")({
        visibility: "hidden"
      });
      const Panel = j("div")({
        position: "absolute",
        left: 0,
        width: "100%",
        height: "51%",
        backgroundColor: "var(--fc-card-bg, #FFC300)",
        backfaceVisibility: "hidden",
        transformStyle: "preserve-3d",
        overflow: "hidden"
      });
      const FrontPanel = j(Panel)({
        top: 0,
        borderTopLeftRadius: "inherit",
        borderTopRightRadius: "inherit",
        zIndex: 2,
        transformOrigin: "center bottom",
        ".flip-text-wrapper": {
          top: 0
        }
      });
      const BackPanel = j(Panel)({
        top: "50%",
        borderBottomLeftRadius: "inherit",
        borderBottomRightRadius: "inherit",
        zIndex: 1,
        transformOrigin: "center top",
        boxShadow: "inset 0 0 .5em rgba(0, 0, 0, .1)",
        ".flip-text-wrapper": {
          transform: "translateY(-50%)",
          height: "200%"
        }
      });
      const Shadow = j("div")({
        position: "absolute",
        height: ".5em",
        bottom: ".125em",
        left: ".15em",
        right: ".15em",
        zIndex: 0,
        boxShadow: "0 .125em .5em rgba(0,0,0,.5),0 .125em .5em rgba(0,0,0,.75)"
      });
      const Divider = j("div")({
        pointerEvents: "none",
        display: "inline-flex",
        width: ".5em",
        svg: {
          width: "50%",
          height: "auto",
          marginLeft: "auto",
          marginRight: "auto",
          color: "var(--fc-dot, #fff)"
        }
      });
      const Container = j("div")({
        position: "relative",
        display: "flex",
        alignItems: "center"
      });
      const DAYS = 1e3 * 60 * 60 * 24;
      const HOURS = 1e3 * 60 * 60;
      const MINUTES = 1e3 * 60;
      function calcRemains(time) {
        const days = Math.floor(time / DAYS);
        const hours = Math.floor(time % DAYS / HOURS);
        const minutes = Math.floor(time % HOURS / MINUTES);
        const seconds = Math.floor(time % MINUTES / 1e3);
        return {
          days,
          hours,
          minutes,
          seconds
        };
      }
      function getRemainTime(time) {
        if (typeof time === "string") {
          time = new Date(time).getTime();
        }
        return Math.max(time - Date.now(), 0);
      }
      function FlipClock(props) {
        const {
          time
        } = props;
        const [remainTime, setRemainTime] = reactExports.useState(getRemainTime(time));
        const tID = reactExports.useRef(0);
        const [animationProgress, setAnimationProgress] = reactExports.useState(0);
        const [shadowOpacity, setShadowOpacity] = reactExports.useState(0);
        const currentRemains = reactExports.useMemo(() => calcRemains(remainTime), [remainTime]);
        const nextRemains = reactExports.useMemo(() => calcRemains(Math.max(0, remainTime - 1e3)), [remainTime]);
        reactExports.useEffect(() => {
          function animateRotate() {
            clearTimeout(tID.current);
            animate(0, 1, {
              duration: 0.6,
              ease: "linear",
              onUpdate(p) {
                setAnimationProgress(p);
                setShadowOpacity(p > 0.75 ? Math.abs(p - 1) / 0.75 : Math.abs(p - 0.25) / 0.5 / 2);
              }
            }).then(() => {
              setAnimationProgress(0);
              setShadowOpacity(0);
              setRemainTime(getRemainTime(time));
            });
            tID.current = window.setTimeout(() => {
              animateRotate();
            }, 1e3);
          }
          animateRotate();
          return () => {
            clearTimeout(tID.current);
          };
        }, [time]);
        if (remainTime <= 0) return /* @__PURE__ */ jsxRuntimeExports.jsx("span", {});
        if (currentRemains.days >= (props.max_days_to_hide || 99)) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx("span", {});
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Container, { className: "flip-clock--container", children: ["days", "hours", "minutes", "seconds"].map((unit, index, arr) => {
          const digits = Array.from(currentRemains[unit].toString().padStart(2, "0"));
          const nextDigits = Array.from(nextRemains[unit].toString().padStart(2, "0"));
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Group, { className: "flip-clock--group", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(GroupTitle, { children: unit }),
              digits.map((digit, i) => {
                let nextDigit = (parseInt(digit) - 1 + 10) % 10;
                if (digit === "0" && i === 0) {
                  switch (unit) {
                    case "days":
                      nextDigit = 9;
                      break;
                    case "hours":
                      nextDigit = 2;
                      break;
                    case "minutes":
                    case "seconds":
                      nextDigit = 5;
                      break;
                  }
                }
                const shouldFlip = nextDigits[i] !== digit;
                const isPrimaryDigit = unit === "seconds" && i === 1;
                const SPEED = 6 / 5;
                const easingP = easeOutBounce(animationProgress * SPEED);
                const easingP2 = easeOutBounce(animationProgress);
                const frontRotation = sall(() => {
                  if (!shouldFlip) return 0;
                  if (isPrimaryDigit) {
                    return Math.max(easingP * -180, -180);
                  }
                  return easingP2 * -180;
                });
                const backRotation = sall(() => {
                  if (!shouldFlip) return -180;
                  if (isPrimaryDigit) {
                    return Math.max(easingP * -180 - 180, -360);
                  }
                  return easingP2 * -180 - 180;
                });
                return /* @__PURE__ */ jsxRuntimeExports.jsxs(Digit, { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(FrontPanel, { style: {
                      transform: "rotateX(0deg)"
                    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "flip-text-wrapper", children: nextDigit }) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(BackPanel, { style: {
                      transform: "rotateX(-180deg)"
                    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "flip-text-wrapper" }) })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { style: {
                    zIndex: 10
                  }, children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(FrontPanel, { style: {
                      transform: `rotateX(${frontRotation}deg)`
                    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "flip-text-wrapper", children: digit }) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(BackPanel, { style: {
                      transform: `rotateX(${backRotation}deg)`
                    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "flip-text-wrapper", children: nextDigit }) })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(FrontPanel, { style: {
                      transform: "rotateX(-180deg)"
                    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "flip-text-wrapper" }) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(BackPanel, { style: {
                      transform: "rotateX(-360deg)"
                    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: "flip-text-wrapper", children: digit }) })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Shadow, { style: {
                    opacity: frontRotation !== 0 ? shadowOpacity : 0
                  } }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, { children: digit })
                ] }, unit + i);
              })
            ] }, unit),
            index !== arr.length - 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "4", height: "10", viewBox: "0 0 4 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "2", cy: "1.76473", r: "1.64706", fill: "currentColor" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "2", cy: "8.35293", r: "1.64706", fill: "currentColor" })
            ] }) })
          ] });
        }) }, "flip-clock");
      }
    }
  };
});
